import React from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function UsersAdmin() {
  const [items, setItems] = React.useState([]);
  const [d, setD] = React.useState({ email: "", name: "", password: "", role: "admin" });
  const load = () => api.listUsers().then(setItems);
  React.useEffect(() => { load(); }, []);
  const save = async () => {
    if (!d.email || !d.name || !d.password) return toast.error("Bitte alle Felder ausfüllen");
    try { await api.createUser(d); setD({ email: "", name: "", password: "", role: "admin" }); load(); toast.success("Nutzer angelegt"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Fehler"); }
  };
  return (
    <div data-testid="admin-users">
      <div className="mb-6"><div className="brut-tag mb-3">CMS / NUTZER</div><h1 className="brut-h2">Admins</h1></div>
      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-7">
          <table className="admin-table w-full">
            <thead><tr className="border-b-2 border-[var(--ink)]"><th className="py-3 text-left">E-Mail</th><th className="py-3 text-left">Name</th><th className="py-3 text-left">Rolle</th></tr></thead>
            <tbody>
              {items.map(u => (
                <tr key={u.id} className="border-b border-[var(--line-soft)]">
                  <td className="py-3 font-mono text-xs">{u.email}</td>
                  <td className="py-3">{u.name}</td>
                  <td className="py-3 font-mono text-xs uppercase">{u.role}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="col-span-12 md:col-span-5">
          <div className="border-2 border-[var(--ink)] p-4 space-y-3 sticky top-6">
            <div className="font-mono text-xs uppercase tracking-[0.2em]">Neuer Admin</div>
            <input className="brut-input" placeholder="E-Mail" value={d.email} onChange={e => setD({ ...d, email: e.target.value })} />
            <input className="brut-input" placeholder="Name" value={d.name} onChange={e => setD({ ...d, name: e.target.value })} />
            <input className="brut-input" placeholder="Passwort" type="password" value={d.password} onChange={e => setD({ ...d, password: e.target.value })} />
            <button onClick={save} className="brut-btn !py-2 !px-3 text-xs">Anlegen</button>
          </div>
        </div>
      </div>
    </div>
  );
}
